const locale = {
  APP_TITLE: 'Mailbox',
  COMPOSE: 'Compose',
  FOLDERS: 'Folders',
  FILTERS: 'Filters',
  LABELS: 'Labels',
  NO_MESSAGES: 'There are no messages!',
  SEARCH_PLACEHOLDER: 'Search for an e-mail or contact',
  INBOX: 'Inbox',
  SENT: 'Sent',
  DRAFTS: 'Drafts',
  SPAM: 'Spam',
  TRASH: 'Trash',
  STARRED: 'Starred',
  IMPORTANT: 'Important',
};

export default locale;
